import React, { useState, useEffect, Fragment } from "react";
import { useParams } from "react-router";
import { useLocation, useHistory } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import CardMedia from "@material-ui/core/CardMedia";
import Grid from "@material-ui/core/Grid";
import AgreeablenessInput from "./AgreeablenessInput";
import PollInput from "./PollInput";
import TokenCard from "../../TokenEarning/TokenCard";
import Firebase from "../../../firebasehelper";
import "./ArticleView.css";
import {
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  YOUTUBE_URL,
  GIF_UPLOAD,
} from "../../../Constants/types";
import { getYoutubeId } from "../../../Utils/utils";
import ReactPlayer from "react-player";
import useWindowSize from "../../../hooks/useWindowSize";

const ArticleView = () => {
  const [article, setArticle] = useState(null);
  const { id } = useParams();
  const { state } = useLocation();
  const width = useWindowSize().width;
  console.log("width:", width);
  const isMobile = width < 600;
  const history = useHistory();
  useEffect(() => {
    loadArticle();
  }, []);
  async function loadArticle() {
    const { brand_name } = state;
    const article = await Firebase.getArticle(brand_name, id);
    setArticle(article);
  }
  const renderLayers = () => {
    const { layers } = article;
    return layers.map((layer) => {
      if (layer.type === "paragraph")
        return (
          <Typography color="textPrimary" className="paragraph">
            {layer.data}
          </Typography>
        );
      else if (layer.type === "standout paragraph")
        return (
          <Typography color="textPrimary" className="standout">
            {layer.data}
          </Typography>
        );
      else if (layer.type === "quote")
        return (
          <Typography color="textPrimary" className="quote">
            "{layer.data}"
          </Typography>
        );
      else if (layer.type === "agreeableness")
        return <AgreeablenessInput content={layer.data} />;
      else if (layer.type === "poll")
        return <PollInput pollHeader={layer.data} answers={layer.answers} />;
      else if (layer.type === "token earning task")
        return <TokenCard item={layer.data} />;
      else if (layer.type === VIDEO_UPLOAD)
        return (
          <ReactPlayer
            url={layer.media_url}
            width="100%"
            height="100%"
            playing={true}
            controls={true}
            muted
          />
        );
      else if (layer.type === YOUTUBE_URL)
        return (
          <iframe
            title="video"
            className="message content-pan"
            src={`//www.youtube.com/embed/${getYoutubeId(
              layer.media_url
            )}?modestbranding=1&showinfo=0`}
            frameBorder="0"
            allowFullScreen
          ></iframe>
        );
      else if (layer.type === IMAGE_UPLOAD || layer.type === GIF_UPLOAD)
        return (
          <img
            src={layer.media_url}
            alt="post_img"
            style={{
              height: 200,
              objectFit: "contain",
            }}
          />
        );
      else {
        console.log("article:", layer);
      }
    });
  };
  return (
    <Fragment>
      <CssBaseline />
      {article && (
        <Container fixed>
          <Grid container direction="column" className="article-container">
            <button
              className="btn btn-yellow btn-back"
              onClick={history.goBack}
            >
              Back
            </button>
            <Typography color="textPrimary" className="heading">
              {article.title}
            </Typography>
            <CardMedia
              image={`${
                isMobile && article.leadMediaMobile
                  ? article.leadMediaMobile
                  : article.leadMedia
              })`}
              className="image"
            />

            <Container maxWidth="md">
              <Typography className="caption">
                BY {article.username} | POSTED ON{" "}
                {new Date(article.time).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
              </Typography>
              <Typography paragraph color="textPrimary" className="paragraph">
                {article.leadParagraph}
              </Typography>
              {renderLayers()}
            </Container>
          </Grid>
        </Container>
      )}
    </Fragment>
  );
};

export default ArticleView;



// WEBPACK FOOTER //
// ./src/screens/Articles/components/ArticleView.js